import React, { useContext, useEffect } from "react";
import Input from "../../../form/Input";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import useMutation from "../../../../hooks/useMutation";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Textarea from "../../../form/Textarea";
import { sendMessage } from "../../../../services/communicationService";
import SocketContext, { useSocket } from "../../../../providers/SocketContext";

const validation = {
  // subject: { required: true, message: "subject is required" },
  email: { required: true, message: "email is required" },
};

const ScholarshipMessage = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  const { socket } = useContext(SocketContext);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({ validationRules: validation });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({ email: data?.userDetails?.email });
    }
  }, [data]);

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await sendMessage({
        ...val,
        scholarshipId: data?.scholarshipDetails?._id || data?.scholarshipId,
        userId: data?.userId,
        chatId: data?.chatId,
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      socket.emit("sendMessage", res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useSocket(
    "sendMessageResponse",
    async (res) => {
      if (res?.status === 200) {
        close();
      }
    },
    [data]
  );

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        {/* <div className="relative col-span-2">
          <Input
            label={"Subject Line"}
            inputPlaceholder={"Enter Your Subject Line"}
            inputName="subject"
            value={values?.subject || ""}
            onChange={handleChange}
            {...formValidate(errors, "subject")}
          />
        </div> */}
        <div className="relative col-span-4">
          <Input
            label={"Enter Email Field"}
            inputPlaceholder={"Enter Your Email Field"}
            inputType={"email"}
            inputName="email"
            value={values?.email}
            onChange={handleChange}
            {...formValidate(errors, "email")}
          />
        </div>
        <div className="relative col-span-4">
          <Textarea
            inputName={"text"}
            label={"Text Field"}
            inputPlaceholder={"Enter Your Text Field"}
            inputValue={values?.text || ""}
            onChange={handleChange}
            {...formValidate(errors, "text")}
          />
        </div>
        <div className="relative col-span-4">
          <FileUploadSingle
            name={data?.attachment?.filename}
            size="small"
            label={"Attach Files"}
            accept={"jpg,jpeg,png,webp,pdf"}
            placeholder="Upload file"
            value={values?.attachment}
            onChange={(file) =>
              handleChange({ target: { name: "attachment", value: file } })
            }
            {...formValidate(errors, "attachment")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Submit"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ScholarshipMessage;
